/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jan 17 2024
 **/

import { useEffect, useRef, DependencyList } from "react";
import EventHandler from "./eventhandler";
import type { Handler } from "./eventhandler";

export default function useEventMessage(name: string, handleMessage: Handler, deps: DependencyList = []) {
	const handlerIndex = useRef(-1);
	useEffect(() => {
		EventHandler.fire("$EventLoop::Register$", name, handleMessage, (index: number) => {
			handlerIndex.current = index;
		});

		return () => {
			EventHandler.fire("$EventLoop::Unregister$", name, handlerIndex.current);
		};
	}, deps);
}
